module.exports = __webpack_public_path__ + "static/img/focus-img.4f913a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/focus-img.png
// module id = maZ1
// module chunks = 1